import Feedback from "./screens/Feedback";

export default Feedback;
